import { SITECORE_USER_TYPES } from '@domain/clubs/types';

import {
  Affiliation,
  ClubAffiliation,
  MembershipType,
} from '@domui-utils/types';

export const getUserType = (
  clubsAffiliations: ClubAffiliation[],
  isDESInfoAvailable: boolean
) => {
  // Treat DES User, Leader by default.
  if (isDESInfoAvailable) {
    return SITECORE_USER_TYPES.LEADER;
  }

  const affiliations = (clubsAffiliations ?? []).reduce(
    (acc: Affiliation[], cur: ClubAffiliation) => {
      const isDistrictEmpty =
        Array.isArray(cur.district) && cur.district.length === 0;

      // If district is empty, skip this entry (return no affiliations)
      if (isDistrictEmpty) return acc;

      return cur.affiliation ? [...acc, ...cur.affiliation] : acc;
    },
    []
  );

  const isMember = (affiliation: Affiliation) =>
    (affiliation.role ||
      affiliation?.type === MembershipType.Member ||
      affiliation.role ||
      affiliation?.type === MembershipType.Rotaractor) &&
    !affiliation.role.toLowerCase().includes('honorary ');
  const member = affiliations.some(isMember);
  // Note: Returning LEADER for member intentionally, member translates to leader behind the scenes.
  return member ? SITECORE_USER_TYPES.LEADER : SITECORE_USER_TYPES.NON_MEMBER;
};
